// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'
import { valueAsMeters } from 'helpers/unitConversion'

// NOTE - the only thing necessary for a segment end antenna is a transmit mode.
// This means that if there's an empty antenna set on the path detail's path ends,
// it will be stored as just the mode. (since there's no null option for mode in UI)

// NOTE - in the DB the only thing necessary to save a segmentEndAntenna is a mode
// however in the UI, if ever there is an antenna, it will have both a mode and an antennaType

// NOTE - when parsing a passive repeater's antenna data, we will always
// have an segment end antenna with an antennaSpecId and centerline.
// This is due to the validation handling of passive repeaters.

const formatAntennas = ants => (
  ants.reduce((a, d) => {
    const {
      antennaType,
      mode,
      segmentEndAntennaId = null,
    } = d

    // a segment end antenna without an antennaSpecId assigned.
    const antennaSpecId = d.antennaSpecId || null
    const centerline = valueAsMeters(d.centerline, d.centerlineUnit)
    const gain = castToFloat(d.gain)

    a.push({
      antennaSpecId,
      antennaType,
      centerline,
      gain,
      mode,
      segmentEndAntennaId,
    })
    return a
  }, [])
)

export default formatAntennas
